import { IconAward, IconLock, IconStar } from "@tabler/icons-react";
import { Trans } from "@lingui/macro";

import type { ToolRequirement } from "../../engine/tools";
import styles from "./ToolRequirement.module.css";

function RequirementText({ requirement }: { requirement: ToolRequirement }): JSX.Element {
  const required = requirement.required;
  return requirement.kind === "level" ? (
    <Trans>Требует ур. {required}</Trans>
  ) : (
    <Trans>Требует реп. {required}</Trans>
  );
}

export function ToolLockChip({ requirement }: { requirement: ToolRequirement }): JSX.Element {
  return (
    <span className={styles.lockChip}>
      <IconLock size={14} aria-hidden="true" />
      <RequirementText requirement={requirement} />
    </span>
  );
}

export function ToolReqMet({ requirement }: { requirement: ToolRequirement }): JSX.Element {
  const Icon = requirement.kind === "level" ? IconStar : IconAward;
  return (
    <span className={styles.reqMet}>
      <Icon size={14} aria-hidden="true" />
      <RequirementText requirement={requirement} /> · <Trans>выполнено</Trans>
    </span>
  );
}
